import { render, staticRenderFns } from "./EvaluacionRespetoPrincipios.vue?vue&type=template&id=46ecbb4d"
import script from "./EvaluacionRespetoPrincipios.vue?vue&type=script&lang=js"
export * from "./EvaluacionRespetoPrincipios.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports